// components/Loader.js

import React from 'react';

const Loader = () => {
  return (
    <div className="loader absolute top-0 left-0 right-0 bottom-0 z-50">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
